import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'rc-tooltip';
import ReactModal from 'react-modal';

import '../../assets/css/bootstrap.css';

// Styles.
import '../../assets/scss/ToggleGroup.css';
import apiRequest from '../../handles/apiRequest';

const ToggleGroup = (
    {prepopulate = '', name, className, onChange, selected = {}}) => {
  // Define states
  const [service, setService] = useState(selected);
  const [services, setServices] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [validPrepopulate, setValidPrepopulate] = useState(false);

  const activateService = (rawService) => {
    const {serviceId, serviceName} = rawService;

    const storedService = {
      ...rawService,
      value: serviceId,
      label: serviceName,
    };

    // Show popup
    if (rawService['isPopup'] === 'true') {
      setShowModal(true);
    }


    // Internal update
    setService(storedService);

    // Parent update
    onChange(storedService);
  };

  // Load services only one time
  useEffect(() => {
    // Get services
    apiRequest({
      method: 'GET',
      endpoint: 'services',
    }).then((data) => {
      setServices(data);
      if (prepopulate) {
        data.forEach((service) => {
          if (prepopulate === service.serviceId) {
            setService({
              ...service,
              value: service.serviceId,
              label: service['serviceName'],
            });
            setValidPrepopulate(true);
            activateService(service);
          }
        });
      }
    });
  }, []);

  return <div {...{name, className}}>
    {services.map(
        (rawService) => {
          const {
            serviceId,
            serviceName, subServiceName, isPopup, imageUrl} = rawService;
          return <div className={'radio-list'} key={serviceId}>
            <input
              type="radio"
              checked={service.value === serviceId}
              value={serviceId}
              id={`${name}-${serviceId}`}
              name={name}
              disabled={validPrepopulate}
              onChange={() => {
                activateService(rawService);
              }}
            />
            <label htmlFor={`${name}-${serviceId}`}>{serviceName}</label>
            <Tooltip placement={'top'} overlay={subServiceName}>
              <span className={'tooltip-icon'}>?</span>
            </Tooltip>
            {service.value === serviceId && isPopup === 'text' &&
            <p
              className={'note'}
              dangerouslySetInnerHTML={{__html: imageUrl}}/>}
          </div>;
        })}
    <ReactModal
      appElement={document.getElementById('root')}
      isOpen={showModal}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
        },
        content: {
          background: 'transparent',
          border: 'none',
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          transform: 'translate(-50%, -50%)',
        },
      }}
    >
      <a className={'popupImage'} href={service['redirectURL']}
        target={'_blank'} rel={'noopener noreferrer'}>
        <img src={service['imageUrl']} alt={service['serviceName']}/>
      </a>
      <button className={'close-button'}
        onClick={() => {
          setShowModal(false);
        }}/>
    </ReactModal>
  </div>;
};

ToggleGroup.propTypes = {
  prepopulate: PropTypes.number,
  name: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func,
  selected: PropTypes.object,
};

export default ToggleGroup;
